<template>
  <div class="modal-overlay" @click.self="cerrarModal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Archivos de {{ nombre_doc }}</h5>
        <button type="button" class="close" @click="cerrarModal">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <span>Subir archivos</span>
          <div
            class="filepond-wrapper"
            style="max-height: 250px; overflow-y: auto"
          >
            <FilePond
              name="file"
              ref="pond"
              label-idle="Arrastra o haz click aquí para seleccionar archivos"
              :allow-multiple="true"
              :allow-file-type-validation="true"
              :accepted-file-types="tiposPermitidos"
              :file-validate-type-detect-type="detectType"
              :max-file-size="maxSize"
              :max-files="maxFiles"
              @addfile="onFileAdd"
              @removefile="onFileRemove"
              :instant-upload="false"
              :allow-reorder="false"
              style-panel-layout="compact"
              @updatefiles="onPondUpdate"
            />
          </div>
          <div class="d-flex justify-content-center m-2">
            <button
              class="btn btn-primary btn-animated px-5 py-2"
              @click="subirArchivosCap()"
              v-if="filesCount > 0"
              :disabled="subiendo"
            >
              <span
                v-if="subiendo"
                class="spinner-border spinner-border-sm mr-2"
                role="status"
                aria-hidden="true"
              ></span>
              {{ subiendo ? "Subiendo..." : "Subir" }}
            </button>
          </div>
        </div>
        <div v-if="archivos_pre?.length > 0">
          <span>Archivos subidos</span>
          <transition-group
            name="smooth-bounce"
            tag="ul"
            class="list-group filepond-wrapper"
            style="max-height: 300px; overflow-y: auto"
          >
            <li
              class="list-group-item d-flex justify-content-between align-items-center"
              v-for="archivo in archivos_pre"
              :key="archivo.id"
            >
              <span>{{ archivo.nombre }}</span>
              <div class="d-flex">
                <div>
                  <button
                    class="btn btn-sm btn-outline-primary mr-1"
                    @click="descargarArchivo(archivo.url)"
                  >
                    <i class="fa fa-regular fa-eye"></i>
                  </button>
                </div>
                <div>
                  <div
                    v-if="archivosEliminando[archivo.id]"
                    class="spinner-border text-danger"
                    role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                  <button
                    v-else
                    class="btn btn-sm btn-outline-danger"
                    @click="eliminarArchivo(archivo.id)"
                  >
                    <i class="fa fa-solid fa-trash"></i>
                  </button>
                </div>
              </div>
            </li>
          </transition-group>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-danger"
          :disabled="isDeleting || !(archivos_pre && archivos_pre.length)"
          @click="eliminarTodosArchivos"
        >
          <span
            v-if="isDeleting"
            class="spinner-border spinner-border-sm mr-2"
            role="status"
            aria-hidden="true"
          ></span>
          Borrar todo
        </button>
        <div
          v-if="uploadProgress > 0"
          class="progress mt-2"
          style="width: 100%"
        >
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            :style="{ width: uploadProgress + '%' }"
            :aria-valuenow="uploadProgress"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
const axiosS3 = axios.create({ withCredentials: false });
import axiosInstance from "../../services/axiosInstance";
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";

import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

import imageCompression from "browser-image-compression";

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize
);

export default {
  name: "ModalFilepond",
  components: { FilePond },
  props: {
    visible: Boolean,
    documentoId: Number,
    nombre_doc: String,
    servicioId: Number,
    index: Number,
    archivos_pre: Array,
    cap: Boolean,
    maxFiles: Number,
  },
  data() {
    return {
      tiposPermitidos: [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/heic",
        "image/heif",
        "image/heic-sequence",
        "image/heif-sequence",
        // videos
        "video/quicktime",
        "video/mp4",
        "video/webm",
        "video/x-msvideo",
        "video/x-matroska",
        "video/mpeg",
        "video/3gpp",
        "video/ogg",
        "video/quicktime",
        "application/pdf",
        "application/zip",
        "application/x-zip-compressed",
        "multipart/x-zip",
        "application/x-rar-compressed",
        "application/vnd.rar",
        "application/x-rar",
        "application/octet-stream",
        "application/x-dwg",
        "application/x-dxf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ],
      maxSize: "50MB",
      uploadProgress: 0,
      subiendo: false,
      totalFiles: 0,
      completedFiles: 0,
      isDeleting: false,
      isCompriming: false,
      archivosEliminando: {},
      ruta: "/pam/guardarArchivo",
      filesCount: 0, // para control interno
    };
  },
  computed: {
    isMobile() {
      return /Android|iPhone|iPad/i.test(navigator.userAgent);
    },
  },
  mounted() {
    const filePondCredits = document.querySelector(
      ".filepond--root .filepond--credits"
    );
    if (filePondCredits) {
      filePondCredits.remove();
    }
  },
  methods: {
    onPondUpdate(fileItems) {
      this.filesCount = fileItems.length; // << reactivo
    },
    async compress(file) {
      const options = {
        initialQuality: 0.9,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      const blob = await imageCompression(file, options);

      return new File([blob], file.name, { type: file.type });
    },
    async eliminarTodosArchivos() {
      if (!this.documentoId) {
        this.flashMessage.error({ message: "Falta documentoId." });
        return;
      }
      if (!this.archivos_pre || this.archivos_pre.length === 0) {
        this.flashMessage.info({ message: "No hay archivos para borrar." });
        return;
      }

      const result = await this.$swal({
        title: "¿Estás seguro que deseas borrar todos los archivos subidos?",
        text: "Esta acción no se puede deshacer.",
        showCancelButton: true,
        confirmButtonText: "BORRAR",
        cancelButtonText: "Cancelar",
        icon: "warning",
        reverseButtons: true,
      });

      if (!result.isConfirmed) return;

      this.isDeleting = true;
      try {
        const ruta = `/cap/eventos-documentos/${this.documentoId}/archivos`;

        await axiosInstance.delete(ruta);

        // Notifica al padre. Puedes mandar null o un flag especial.
        this.$emit("archivo-eliminado", { all: true });

        this.flashMessage.success({
          message: "Se borraron todos los archivos.",
        });
      } catch (err) {
        console.error(err);
        this.flashMessage.error({
          message: "Error al borrar todos los archivos.",
        });
      } finally {
        this.isDeleting = false;
      }
    },
    detectType(source, currentType) {
      return new Promise((resolve) => {
        if (!currentType || currentType === "application/octet-stream") {
          const name = (source.name || "").toLowerCase();
          if (name.endsWith(".dwg")) return resolve("application/x-dwg");
          if (name.endsWith(".dxf")) return resolve("application/x-dxf");
        }
        resolve(currentType);
      });
    },
    cerrarModal() {
      this.$emit("close-modal");
    },
    async onFileAdd(error, fileItem) {
      if (error) {
        // lo quita visualmente y ya no aparecerá en tu counts
        this.$refs.pond.removeFile(fileItem.id);
        this.flashMessage.warning({
          message:
            "Uno o varios archivos no han sido cargados debido a que superan el tamaño máximo (100 MB).",
        });
        return;
      }
    },
    onFileRemove() {},
    async eliminarArchivo(idArchivo) {
      this.$set(this.archivosEliminando, idArchivo, true);
      try {
        await axiosInstance.delete(`/pam/eliminarArchivo/${idArchivo}`);
        this.$emit("archivo-eliminado", idArchivo);
        this.flashMessage.success({
          message: "Archivo eliminado correctamente",
        });
      } catch (err) {
        console.error(err);
        this.flashMessage.error({ message: "Error al eliminar el archivo" });
      } finally {
        this.$delete(this.archivosEliminando, idArchivo);
      }
    },
    descargarArchivo(nombreArchivo) {
      if (!nombreArchivo) return;

      axiosInstance
        .post("/pam/vistaPreviaArchivo", { file: nombreArchivo })
        .then((response) => {
          if (response.data) {
            const url = response.data;
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank"; // abre en nueva pestaña
            link.rel = "noopener noreferrer";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch(() => {
          this.flashMessage.error({
            message: "[ERROR]: Ocurrió un error al descargar el archivo.",
          });
        });
    },
    async subirArchivosCap() {
      const items = this.$refs.pond?.getFiles() || [];
      if (!items.length) return;

      // TOMAR SOLO Files válidos (no los items)
      const files = items.map((it) => it.file).filter((f) => !!f);

      this.subiendo = true;
      this.uploadProgress = 0;
      this.completedFiles = 0;
      this.totalFiles = files.length;

      const lote = 8;
      try {
        for (let i = 0; i < files.length; i += lote) {
          const slice = files.slice(i, i + lote);
          await Promise.all(slice.map((file) => this.subirUno(file)));
        }

        this.$refs.pond && this.$refs.pond.removeFiles();
        this.uploadProgress = 100;
      } catch (e) {
        console.error("Error al subir archivos:", e);
        this.flashMessage.error({
          message: "Error al subir algunos archivos.",
        });
      } finally {
        setTimeout(() => {
          this.subiendo = false;
          this.uploadProgress = 0;
        }, 300);
      }
    },
    async subirUno(file) {
      const fileName = file.name || "archivo";
      const contentType = file.type || "application/octet-stream";

      // 1) Firma
      const { data } = await axiosInstance.post("/cap/sign", {
        fileName,
        contentType,
        eventosDocumentosId: this.documentoId,
      });
      const { key, url } = data;

      // 2) Comprimir si es imagen
      const type = (file?.type || "").toLowerCase();
      const esImagenNormal = /^image\/(jpeg|png|gif|webp)$/.test(type);
      const toUpload = esImagenNormal ? await this.compress(file) : file;

      // 3) PUT a S3 (con content-type)
      await axiosS3.put(url, toUpload, {
        headers: { "Content-Type": contentType },
      });

      // 4) Registrar en backend
      const response = await axiosInstance.post("/cap/guardarArchivo", {
        eventosDocumentosId: this.documentoId,
        key,
        nombre: fileName,
      });

      // 5) Progreso por conteo
      this.completedFiles += 1;
      this.uploadProgress = Math.round(
        (this.completedFiles / this.totalFiles) * 100
      );

      // 6) Notificar
      this.$emit("archivo-subido", {
        index: this.index,
        nota: null,
        archivos: response.data,
      });
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.285); /* Fondo oscuro estilo modal */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050; /* Como los modales de Bootstrap */
}

.modal-content {
  background-color: #fff;
  border-radius: 0.3rem;
  max-width: 600px;
  width: 100%;
  overflow: hidden;
  animation: fadeIn 0.3s ease-out;
}

.modal-header,
.modal-footer {
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.modal-header {
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  padding: 1rem;
  max-height: 70vh;
  overflow-y: auto;
}

.close {
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

div.filepond--root .filepond--credits {
  display: none !important;
}

/* Transición general */
.smooth-bounce-enter-active {
  transition: transform 0.4s ease-in-out, opacity 0.4s ease-in-out,
    background-color 2s ease-in-out; /* Duración más larga para que el color verde se desvanezca suave */
}

/* Estado inicial: opaco, escalado, y con fondo verde */
.smooth-bounce-enter {
  opacity: 0;
  transform: scale(0.95) rotate(0deg) translateY(10px);
  background-color: #d4edda; /* Verde claro tipo "success" (puedes ajustar) */
}

/* Estado final: tamaño normal, opacidad 1, fondo normal */
.smooth-bounce-enter-to {
  opacity: 1;
  transform: scale(1) rotate(0deg) translateY(0);
  background-color: transparent; /* Se desvanece al color original */
}

.btn-animated {
  width: 100%;
  animation: pulse 1.5s infinite;
  transition: transform 0.3s ease-in-out;
  font-weight: 500;
  border-radius: 0.5rem;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.5);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(13, 110, 253, 0);
    transform: scale(1.03);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0);
    transform: scale(1);
  }
}
</style>
